import { yup } from '@guiker/yup-util'

export const addressSchema = yup.object({
  city: yup.string().required(),
})
